export const VOLUME_STEP = 10;
export const VOLUME_MULTIPLIER = 100;
export const DEFAULT_SPEED_OPTIONS = [2, 1.75, 1.5, 1.25, 1, 0.75, 0.5];
export const PLAYBACK_ACTIONS = ({
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  STEP_FORWARD: 'STEP_FORWARD',
  STEP_BACKWARD: 'STEP_BACKWARD',
  SKIP_TO_START: 'SKIP_TO_START',
  SKIP_TO_END: 'SKIP_TO_END'
} as const);